import { http } from '../rest';

export function completeAdvisorAttestation(http, demo) {
  return {
    async execute({ selectedUserIds, firmConfirmation }) {
      const params = {
        selected_user_ids: selectedUserIds,
        firm_confirmation: firmConfirmation,
      };

      try {
        if (demo) {
          return true;
        }
        await http.post('/handle_advisor_completed_attestation', params);
      } catch (error) {
        if (error && error.response && error.response.status === 404) return;
        throw error;
      }
    },
  };
}

export default completeAdvisorAttestation(http, process.env.DEMO);
